import { Field } from "formik";
import TextFieldCustom from "../components/TextFieldCustom/TextFieldCustom";
import { useFormInputHelpers } from "./useFormInputHelpers";

const FormTextInput = ({
  name,
  onChange,
  className,
  classNames = {},
  shouldHaveErrorBehaviorAfterSubmit,
  helperText,
  corners,
  ...props
}) => {
  const { shouldDisplayError, finalHelperText } = useFormInputHelpers({
    name,
    shouldHaveErrorBehaviorAfterSubmit,
    helperText,
  });

  return (
    <Field
      name={name}
      as={TextFieldCustom}
      helperText={finalHelperText}
      isError={shouldDisplayError}
      corners={corners}
      className={className}
      classNames={classNames}
      {...(typeof onChange === "function" ? { onChange } : {})}
      {...props}
    />
  );
};

export default FormTextInput;
